import { Controller } from '@hotwired/stimulus';

import { Calendar } from '@fullcalendar/core';

import dayGridPlugin from '@fullcalendar/daygrid';

import interactionPlugin from '@fullcalendar/interaction';

import esLocale from '@fullcalendar/core/locales/es';

import { Modal } from 'bootstrap';

export default class extends Controller {

    static values = {
        url: String
    };

    declare readonly urlValue: string;

    connect(): void {

        const calendar = new Calendar(
            this.element as HTMLElement,
            {

                // =====================================
                // PLUGINS
                // =====================================

                plugins: [
                    dayGridPlugin,
                    interactionPlugin
                ],

                locale: esLocale,

                initialView: 'dayGridMonth',

                height: 'auto',

                fixedWeekCount: false,

                dayMaxEvents: 3,

                moreLinkClick: 'popover',

                // =====================================
                // HEADER
                // =====================================

                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: ''
                },

                // =====================================
                // RANGE
                // =====================================

                validRange: () => {

                    const start = new Date();

                    const end = new Date();

                    end.setMonth(
                        end.getMonth() + 3
                    );

                    return {
                        start,
                        end
                    };
                },

                // =====================================
                // LOAD EVENTS
                // =====================================

                events: async (
                    _fetchInfo,
                    successCallback,
                    failureCallback
                ) => {

                    try {

                        const response = await fetch(
                            this.urlValue
                        );

                        const data =
                            await response.json();

                        successCallback(data);

                    } catch (e) {

                        failureCallback(
                            e as Error
                        );
                    }
                },

                // =====================================
                // COLORS
                // =====================================

                eventClassNames: (arg) => {

                    const status =
                        arg.event.extendedProps.status;

                    if (status === 'past') {

                        return [
                            'bg-danger',
                            'border-danger',
                            'text-white'
                        ];
                    }

                    if (status === 'today') {

                        return [
                            'bg-success',
                            'border-success',
                            'text-white'
                        ];
                    }

                    return [
                        'bg-warning',
                        'border-warning',
                        'text-dark'
                    ];
                },

                // =====================================
                // TOOLTIP
                // =====================================

                eventDidMount: (info) => {

                    const props =
                        info.event.extendedProps;

                    info.el.setAttribute(
                        'title',
                        `
${info.event.title}

Edad: ${props.age}

Teléfono: ${props.phone ?? '-'}

Tags:
${props.tags ?? '-'}
                        `
                    );
                },

                // =====================================
                // MODAL
                // =====================================

                eventClick: (info) => {

                    const props =
                        info.event.extendedProps;

                    const modalBody =
                        document.getElementById(
                            'birthdayModalBody'
                        );

                    if (!modalBody) {
                        return;
                    }

                    modalBody.innerHTML = `
                        <div class="text-center">

                            ${props.image
                            ? `
                                <img
                                    src="/images/registers/${props.image}"
                                    class="rounded-circle mb-3"
                                    width="120"
                                    height="120"
                                    style="object-fit: cover;"
                                >
                            `
                            : ''
                        }

                            <h4 class="mb-3">
                                ${info.event.title}
                            </h4>

                            <div class="mb-2">
                                <strong>Edad:</strong>
                                ${props.age}
                            </div>

                            <div class="mb-2">
                                <strong>Teléfono:</strong>
                                ${props.phone ?? '-'}
                            </div>

                            <div class="mb-2">
                                <strong>Tags:</strong>
                                ${props.tags ?? '-'}
                            </div>

                            <div class="mb-2">
                                <strong>Fecha:</strong>
                                ${props.date ?? '-'}
                            </div>

                            <div class="mt-3">
                                <a target="_blank" href="${props.editUrl}" class="btn btn-warning btn-sm">
                                    <i class="bi bi-pencil"></i> Editar registro
                                </a>
                            </div>

                        </div>
                    `;

                    const modalElement =
                        document.getElementById(
                            'birthdayModal'
                        );

                    if (!modalElement) {
                        return;
                    }

                    const modal =
                        new Modal(modalElement);

                    modal.show();
                }
            }
        );

        calendar.render();
    }
}
